import p from "./_MapCache.js";
var o = p, u = "Expected a function";
function r(i, e) {
  if (typeof i != "function" || e != null && typeof e != "function")
    throw new TypeError(u);
  var a = function() {
    var c = arguments, n = e ? e.apply(this, c) : c[0], t = a.cache;
    if (t.has(n))
      return t.get(n);
    var h = i.apply(this, c);
    return a.cache = t.set(n, h) || t, h;
  };
  return a.cache = new (r.Cache || o)(), a;
}
r.Cache = o;
var m = r;
export {
  m as default
};
//# sourceMappingURL=memoize.js.map
